// @flow
import React from 'react'
import Overpanel from 'react-components/overpanel'
import SendCurrencyConversionSelection from '../send-currency-conversion-selection'
import { connect } from '../../utils/p2p-connect'
import { toggleCurrencyConversionOverpanel } from 'transfer/actions/overpanels'

function CurrencyConversionSelectionOverpanel({
  show,
  handleClose,
}: Overpanel) {
  return (
    <Overpanel
      show={show}
      handleClose={handleClose}
      pageGroup="main:consumer:p2p:transfer:currencyConversionOption"
      pageName="main:consumer:p2p:transfer:currencyConversionOption:::node"
    >
      <SendCurrencyConversionSelection />
    </Overpanel>
  )
}

export default connect(
  ({ overpanels }) => ({
    show: overpanels.currencyConversion,
  }),
  dispatch => ({
    handleClose: () =>
      dispatch(toggleCurrencyConversionOverpanel({ show: false })),
  })
)(CurrencyConversionSelectionOverpanel)
